module.exports = __webpack_public_path__ + "static/media/logo-vodovod-split.992d458b.jpg";